import { useQuery } from '@apollo/client'
import { useMemo } from 'react'
import { CargosQuery, CargosQueryVariables } from '@/core/types/graphql'
import { CARGOS_QUERY } from '@/modules/usuarios-edicao/data/cargos'
import { OptionSelect } from '@/core/utils/types'

export const useCargos = (cargosPrincipais: string[] = []) => {
  const { data, loading } = useQuery<CargosQuery, CargosQueryVariables>(
    CARGOS_QUERY,
    {
      fetchPolicy: 'network-only',
      variables: { cargosPrincipais }
    }
  )

  const cargos = useMemo(() => data?.cargos ?? [], [data])

  const cargosOptions = useMemo(
    () =>
      cargos.map(it => ({ label: it?.nome, value: it?.id })) as OptionSelect[],
    [cargos]
  )

  return {
    cargos,
    cargosOptions,
    hasCargos: cargos.length > 0,
    loading
  }
}
